<template>
  <div class="edit-profilebox add-new-memberbox savingaccount-formbox">
    <ul class="breadcrumbs-list">
      <a  @click="backButton"><li>Investment</li></a>
      <a  @click="depositeDashbord"><li>&nbsp;>&nbsp;Mutual Funds Details</li></a>
      <a  @click="depositeAccounts"><li>&nbsp;>&nbsp;Mutual Funds</li></a>

      <li>&nbsp;>&nbsp;Lumpsum Investment</li>
    </ul>
    <h4 class="welcome-text">Lumpsum Investment</h4>
    <div>
      <div class="edit-profilebox-detail">
        <v-form
          ref="form"
          id="saving_account"         
          @submit.prevent
          class="login-form-box register-page"
          lazy-validation
        >
            <h4>Enter Details</h4>
            <v-row >
              <v-col xs="12" md="6" class="member_relation_box col" v-for="formAttr in formAttributes" :key="formAttr.id">
                <label class="member-label" v-if="formAttr['name'] =='current_value'"></label> 
                <label class="member-label" v-else-if="formAttr['name'] =='nav'">Nav on {{ currentDate | moment("DD MMM, Y")}}</label>
                <label class="member-label" v-if="formAttr['name']=='balance_units'">{{formAttr['label']}}  <a href="javascript:void(0)" v-on:click="getAccountHelpDetail()" title="Get account help">Get Help</a></label>
                <label class="member-label" v-else>{{ formAttr['label'] }} </label>
                <div v-if="formAttr['type'] == 'select' && formAttr['name'] !='nominee'">
                  <v-autocomplete
                    v-if="formAttr['name'] == 'scheme_type' || formAttr['name'] == 'scheme_name'"
                    ref="form_attrs"
                    :name="formAttr['name']"
                    :v-model="formAttr['name']"
                    :items="(formAttr['name']=='mutual_fund_company' )? mutual_fund_company : (formAttr['name']=='scheme_type') ? scheme_type : (formAttr['name']=='account_owner')? account_owner :(formAttr['name']=='scheme_name')? scheme_name : ((formAttr['name']=='nominee')) ? joint_account_owner :(formAttr['name']=='joint_account_owner')? joint_account_owner:familyMember"
                    item-value="id"
                    item-text="name"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                  ></v-autocomplete>
                  <v-select
                    v-else
                    ref="form_attrs"
                    :name="formAttr['name']"
                    :v-model="formAttr['name']"
                    :items="(formAttr['name']=='mutual_fund_company' )? mutual_fund_company : (formAttr['name']=='scheme_type') ? scheme_type : (formAttr['name']=='account_owner')? account_owner :(formAttr['name']=='scheme_name')? scheme_name : ((formAttr['name']=='nominee')) ? joint_account_owner :(formAttr['name']=='joint_account_owner')? joint_account_owner:familyMember"
                    item-value="id"
                    item-text="name"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                  ></v-select>
                </div>
                <div v-else-if="formAttr['type'] == 'select' && formAttr['name'] =='nominee'">
                   <v-combobox
                    :ref="formAttr['name']"
                    :name="formAttr['name']"
                    v-model="addMoreField"
                    :items="nominee"
                    item-value="id"
                    item-text="name"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                    multiple
                    small-chips
                    solo
                    v-on:input="limiter"
                    deletable-chips
                  ></v-combobox>
                  <a @click="appendField" class="add-newbox">Add New Nominee</a>
                </div>
                <div v-else-if="formAttr['type'] == 'input' && formAttr['name'] != 'folio_no'" :class=" formAttr['icon'] == 'rupyee.png' ? 'rupee-icon' : ''">
                    <v-text-field
                    :name="formAttr['name']"
                    ref="form_attrs"
                    :rules="[(formAttr['is_required'] ==true ? v => !!v || 'Field is required':[]),(formAttr['is_numeric'] ==true ? v => /^\d{0,8}[.]?\d{1,2}$/ .test(v) || 'Field must be numeric':[])]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    @input="calculateAmounts($event,formAttr['name'])"
                    :readonly="formAttr['name'] == 'nav' || formAttr['name'] == 'current_value'"
                    :value="formAttr['name'] == 'nav'? current_nav : formAttr['name'] == 'current_value' ? current_value : ''"
                    ></v-text-field>
                </div>
                <div v-else-if="formAttr['type'] == 'input' && formAttr['name'] == 'folio_no'">
                    <v-text-field
                    :name="formAttr['name']"
                    ref="form_attrs" 
                    :rules="formAttr['is_required'] == false ? [ v => !v || /^(?=.*[0-9])[a-zA-Z0-9]+$/.test(v) || 'Field must be alphanumeric or numeric']:[]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    @input="changeTextFieldEvent"
                    ></v-text-field>
                </div>
                <div v-else-if="formAttr['type'] == 'date'" class="dob-box">
                  <Datepicker
                    :name="formAttr['name']"
                    ref="form_attrs"
                    :v-model="formAttr['name']"
                    format="dd MMM, yyyy"
                    :placeholder="formAttr['place_holder']"
                    @selected="calculateAmountsWithDates($event, formAttr['name'])"
                  ></Datepicker>
                </div>
              </v-col>
            </v-row>
            <span
              v-bind:class="{'error-messagebox-login': isAddClassServerError}"
              id="server_side_error"
              >{{serverError}}</span
            >
            <v-row class="buttonbox">
              <v-btn class="blue-border-btn" @click="depositeAccounts"> Cancel </v-btn>
              <v-btn
                class="blue-btn"
                @click="submit"
                :disabled="!isFormValid"
              >
                Save
              </v-btn>
            </v-row>
          </v-form>
      </div>
    </div>
    <v-dialog v-model="account_help_dialog" persistent  width="507">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"  v-if="this.sms_array != ''" style="word-break: break-word;">
            You can get the number of units held in your folio from your account statement by sending an SMS as specified below.
          </v-card-title>
          <v-card-title class="text-h5 grey lighten-2" v-else>
            You can get the number of units held in your fund from your account statement by clicking on the link below.
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col>
                       
              </v-col>  
            </v-row> 
            <div class="custom-notiBox">
              <v-layout class="notificationbox">
                <div class="noti-box inner-notificationbox">
                  <v-card class="imagebox" v-if="this.sms_array != ''">
                    <div class="noti-innerBox" >
                      <h4 style="padding-top:10px !important">Send SMS ({{this.sms_array.sms_str}}) to {{this.sms_array.sms_no}}</h4>
                      <v-img max-height="25" max-width="25" :src="sms_icon" :lazy-src="sms_icon"></v-img>
                    </div>
                    <div class="noti-innerBox">
                      <h4 style="padding-top:10px !important">The password length must be 6 characters, and must contain atleast 2 numbers and 2 alphabets.</h4>
                    </div>
                    <div class="noti-innerBox">
                      <h4 style="padding-top:10px !important">Note: You will receive the account statment in your email registered against the foilo.</h4>
                    </div>
                  </v-card>
                  <v-card class="imagebox" v-else>
                    <div class="noti-innerBox">
                      <h4 styler="padding-top:10px !important">
                        You have to enter your registered Email ID and enter a self-extracted pasword. Check your registered Email ID to view the statement. Use password to open the statement.
                      </h4>
                    </div>
                    <div class="noti-innerBox">
                      <h4 style="padding-top:10px !important">You can obtain your Consolidated Account Statement of your holdings across Kfintech serviced mutual funds by clicking on the link below.</h4>
                    </div>
                    <div class="noti-innerBox">
                      <h4 style="padding-top:10px !important"><a href="https://mfs.kfintech.com/investor/General/AccountStatement" title="Click here to get account statement" target="blank">Click here to get Account Statement</a></h4>
                    </div>
                  </v-card> 
                </div>
              </v-layout>
            </div>   
          </v-card-text>


          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="account_help_dialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { validationMixin } from 'vuelidate'
import {required, email, minLength, sameAs, isAlphanumeric, alpha, numeric, maxLength} from "vuelidate/lib/validators";
import { Auth } from 'aws-amplify';
import { POST_API, GET_API, GET_LUMPSUM_INVESTMENT_FORM_DATA, GET_SCHEME_NAME_DATA, GET_SCHEME_NAME_DETAIL, SAVE_MUTUALFUND_DATA, GET_MUTUAL_FUND_DATA } from "../../store/actions.type";

import { isEmpty } from 'lodash';
import axios from "axios";
export default {
    components: {
      Datepicker,
    },
    mixins: [validationMixin],
    validations: {
     
    },
    data: () => ({
      valid: true,
      submitted: false,
      activePicker: null,
      menu: false,
      isFormValid:false,
      disabledDates: {
        from: new Date()
      },
      serverError:'',
      isAddClassServerError:false,
      formAttributes:'',
      formAttr:'',
      other_form_field:[],
      mutual_fund_company:[],
      scheme_type:[],
      familyMember:[],
      nominee:[],
      other_nominee:[],
     
      curr_balance_date: '',
      account_type:'',
      bank_name:'',
      account_owne:'',
      addMoreField:[],
      nomineeMembers:[],
      form_id:'',
      account_owner:[],
      depositor_name:[],
      nominee:[],
      current_balance_value:'',
      maturity_balance_value:'',
      joint_account_owner:[],
      currentDate: new Date().setDate(new Date().getDate()),
      scheme_name:[],
      current_nav:'',
      current_value:'',
      scheme_type_id:'',
      mfc_id:'',
      unitBalanceVaue: 0,
      sms_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'sms_icon.png',
      whatsapp_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'whatsapp_icon.png',
      phone_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'phone_icon.png',
      getFormData:'',
      account_help_array:[],
      missed_call_no_array:"",
      sms_array:"",
      whatsapp_no_array:"",
      account_help_dialog: false,
    }),
    computed: {
      buttonErrorMessage(){    
    },

    },
    created (){
      Fire.$on("loadData", () => {
        this.getLumpsumInvestmentAddFormDetails();
      });
    },
    mounted (){

      if (isEmpty(this.$store.getters.getLumpsumInvestmentFormData)) {
        this.getLumpsumInvestmentAddFormDetails();
      } else {

        this.allow_nominee = this.$store.getters.getLumpsumInvestmentFormData.allow_nominee;
        this.form_id = this.$store.getters.getLumpsumInvestmentFormData.data.form_id;
        this.formAttributes = this.$store.getters.getLumpsumInvestmentFormData.data.form_attributes.fields;

          let masterDataArr = this.$store.getters.getLumpsumInvestmentFormData.data.master_data;

          masterDataArr.forEach(element => {

          if (element.MutualFundCompany) {
            element.MutualFundCompany.forEach(dataAccountType => {
              this.mutual_fund_company.push({'id':dataAccountType.id, 'name':dataAccountType.name});
            });
          }
          if (element.FamilyMember) {
            element.FamilyMember.forEach(dataFamily => {
              this.nominee.push(dataFamily.name);
              if(dataFamily.id == 0){
                this.account_owner.push({'id':'0', 'name':dataFamily.name});
              }
              else{
                this.account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
              }
              this.depositor_name.push({'id':dataFamily.id, 'name':dataFamily.name});
              this.joint_account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
            });
          }
          if (element.SchemeType) {
            element.SchemeType.forEach(schemeType => {
              this.scheme_type.push({'id':schemeType.id, 'name':schemeType.name});
            });
          }
          });        

      }

    },
    methods: {
      changeTextFieldEvent(e) {
        this.isFormValid = this.$refs.form.validate()
      },
      limiter(e) {
        if((e.length + this.other_form_field.length) > 3) {
          swal.fire({
            title: 'Nominee',
            text: "You can add maximum 3 nominees.",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            if (result.isConfirmed) {
              e.pop();
              return;
             
            }
          })
        }
      },
      validate () {
        this.$refs.form.validate()
      },
      backButton(){
        this.$router.push({ name: 'Investment'}).catch(()=>{});
      },
      depositeAccounts(){
        this.$router.push({ name: 'SubCategory'}).catch(()=>{});
      },
      appendField(){
        swal.fire({
          input: 'text',
          inputPlaceholder: 'Enter Nominee',
          inputAttributes: {
          autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: `Save`,
          allowOutsideClick: false,
          allowEscapeKey: false
          }).then((result) => {
            if (result.value) {
             let letters = /^[A-Za-z]+$/;
              if(result.value.length > 30){
                 swal.fire({
                  title: 'Nominee',
                  text: "Nominee Name may not be greater than 30 character.",
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonColor: '#051d42',
                  confirmButtonText: 'OK',
                  }).then((result) => {
                  if (result.isConfirmed) {
                    e.pop();
                    return;
                  }
                })
              }else if(result.value.match(letters))
                {
                  
                this.nominee.push(result.value);
                this.addMoreField.push(result.value);
                }
              else
                {
              swal.fire({
              title: 'Nominee',
              text: "Please enter valid name.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              confirmButtonText: 'OK',
              }).then((result) => {
              if (result.isConfirmed) {
                e.pop();
                return;
               
              }
            })
                }
              
            }
 if (result.value == "") {
            swal
              .fire({
                title: "Nominee",
                text: "This field is required.",
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#051d42",
                confirmButtonText: "OK",
              })
              .then((result) => {
                if (result.isConfirmed) {
                  e.pop();
                  return;
                }
              });
          }
          })
         
        if (this.addMoreField.length >= 3) {
         swal.fire({
            title: 'Nominee',
            text: "You can add maximum 3 nominees.",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            if (result.isConfirmed) {
              e.pop();
              return;
             
            }
          })
        }
      },
      removeField (lineId) {
        this.other_form_field.splice(lineId, 1);
      },
      setData(key){
        
      },
      submit(e) {
        this.checkFormData = [];
        let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        if(this.checkFormData.length > 0){
        this.submitted = true;
        let jsonObject = []
        let nominee    = []
        let i=0;
        for (const [key, value] of formData.entries()) {
          if(key == 'nominee' && value !=''){
            value.split(",").forEach(nomineeData => {
              nominee.push(nomineeData)
            });
          }
          else if(Number.isInteger(parseInt(key)) == true){
            nominee.push(value)
          }
          else if(key == 'scheme_type'){
            if(!isNaN(value) == true)
            {
             jsonObject.push({"key":key, "values":value})
            }else{
               continue;
            }
          }else if(key == 'scheme_name'){
             if(!isNaN(value) == true)
             {
              jsonObject.push({"key":key, "values":value})
             }else{
              continue;
            }
          }
          else if(key == 'mutual_fund_company' || key == 'scheme_type' || key == 'account_owner'|| key == 'scheme_name'){
            jsonObject.push({"key":key, "values":parseInt(value)})
          }
          else{
            if(key != 'nominee'){
              jsonObject.push({"key":key, "values":value})
            }
          }
          i++;
        }
        let nomineeArr = {"key":"nominee", "values":nominee}
        jsonObject.push(nomineeArr)
        let collected_data = {"collected_data":jsonObject};
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        this.$store.dispatch(SAVE_MUTUALFUND_DATA, {
          data: {
            aws_cognito_id: cognito_idp,
            form_id:this.form_id,
            account_owner:getFormData.account_owner.value,
            form_detail:JSON.stringify(collected_data),
            scheme_type_id:this.scheme_type_id,
            mfc_id:this.mfc_id,
          },
          api: 'save-mutual-fund-data',
        }).then(() => {
          this.getMutualFundData();
          this.$loading(false)
          Toast.fire({
            icon: 'success',
            title: 'Data saved successfully.'
          })
          this.$router.push({ name: "mutual-dashboard", params: { tab: 'tab-' + this.scheme_type_id, from:'add' }}).catch(()=>{});
        }).catch(() => {
            this.$loading(false)
        })
      }
       
      },
      setMasterData:function(attr_type, val){
        this.isFormValid = this.$refs.form.validate()
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        if(attr_type == 'mutual_fund_company'){
         return this.mfc_id = val;
        }
        if (attr_type == 'scheme_type') {
         
          this.scheme_name = [];
           this.scheme_type_id = val;
          this.$store.dispatch(GET_SCHEME_NAME_DATA, {
          data: {
            sheme_type_id:val,
            mfc_id:this.mfc_id,
            aws_cognito_id: cognito_idp,
          },
          api: 'get-scheme-name',
          }).then(() => {
            this.scheme_name = [];
            this.$store.getters.getSchemeNameData.data.forEach(schemeName => {
              this.scheme_name.push({'id':schemeName.id, 'name':schemeName.name});
            })

          }).catch(() => {

          })
        }

        if (attr_type == 'scheme_name') {
          this.$store.dispatch(GET_SCHEME_NAME_DETAIL, {
          data: {
            id:val,
            aws_cognito_id: cognito_idp,
          },
          api: 'get-scheme-name-detail',
          }).then(() => {

           this.current_nav = this.$store.getters.getSchemeNameDetail.data.current_nav;
           if(getFormData.balance_unit.value !=''){
                this.current_value = (this.$store.getters.getSchemeNameDetail.data.current_nav * getFormData.balance_unit.value);
           }

          }).catch(() => {

          })
        }
        if (attr_type == 'account_owner') {
          let masterDataArr = this.$store.getters.getLumpsumInvestmentFormData.data.master_data;
          let i = 0;
          this.nominee = [];
          this.depositor_name = [];
          this.joint_account_owner = [];
          masterDataArr['1']['FamilyMember'].forEach(
            familyMember => {
              if (parseInt(val) != parseInt(familyMember['id'])) {
                  //if (familyMember.id != '') {
                    this.nominee.push(familyMember.name);
                 // }
                  this.joint_account_owner.push({'id':familyMember.id, 'name':familyMember.name});
                  this.depositor_name.push({'id':familyMember.id, 'name':familyMember.name});
              }
              i++;
          });
        }

      },
      appendFieldOnNominee(attr_type, val){
        this.nominee.push(val);
        this.addMoreField.push(val);
        this.other_form_field.splice(attr_type, 1);
      },
      depositeDashbord(){
        this.$router.push({ name: "mutual-dashboard"}).catch(()=>{});
      },

      calculateAmounts(unitBalance,fieldName){
        this.isFormValid = this.$refs.form.validate()
        let getFormData = document.querySelector("#saving_account");
        if (fieldName == 'balance_units') {
           this.unitBalanceVaue  = isEmpty(unitBalance) ? 0 : unitBalance;
        }

        if (getFormData.nav.value && this.unitBalanceVaue) {
          this.current_value = (getFormData.nav.value * this.unitBalanceVaue);
          return this.current_value = parseFloat(this.current_value).toFixed(2)
        }
      },

      getLumpsumInvestmentAddFormDetails(){
        if(this.$store.getters.getUserDetails.user_name){ 
          this.$loading(true)
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let user_name = this.$store.getters.getUserDetails.user_name;
          let selected_value = this.$store.getters.getUserDetails.selected_value;
          this.$loading(true);
          this.$store
          .dispatch(GET_LUMPSUM_INVESTMENT_FORM_DATA, {
            data: {
              aws_cognito_id: cognito_idp,
              user_name:user_name,
              form_type: 31,
            },
            api: "get-form",
          })
          .then(() => {
            this.allow_nominee = this.$store.getters.getLumpsumInvestmentFormData.allow_nominee;
            this.form_id = this.$store.getters.getLumpsumInvestmentFormData.data.form_id;
            this.formAttributes = this.$store.getters.getLumpsumInvestmentFormData.data.form_attributes.fields;
            let masterDataArr = this.$store.getters.getLumpsumInvestmentFormData.data.master_data;
            masterDataArr.forEach(element => {
            if (element.MutualFundCompany) {
              element.MutualFundCompany.forEach(dataAccountType => {
                this.mutual_fund_company.push({'id':dataAccountType.id, 'name':dataAccountType.name});
              });
            }
            if (element.FamilyMember) {
              element.FamilyMember.forEach(dataFamily => {
                this.nominee.push(dataFamily.name);
                if(dataFamily.id == 0){
                  this.account_owner.push({'id':'0', 'name':dataFamily.name});
                }
                else{
                  this.account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
                }
                this.depositor_name.push({'id':dataFamily.id, 'name':dataFamily.name});
                this.joint_account_owner.push({'id':dataFamily.id, 'name':dataFamily.name});
              });
            }
            if (element.SchemeType) {
              element.SchemeType.forEach(schemeType => {
                this.scheme_type.push({'id':schemeType.id, 'name':schemeType.name});
              });
            }
          });
            this.$loading(false)
          }).catch(() => {
           this.$loading(false);
         });
        }

      },

      getMutualFundData(){
          this.$loading(true) 
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let user_name = this.$store.getters.getUserDetails.user_name;
          let selected_value = this.$store.getters.getUserDetails.selected_value;
          selected_value = selected_value ? selected_value : '';
          this.$store.dispatch(GET_MUTUAL_FUND_DATA, {
            data: {
              aws_cognito_id:cognito_idp,
              member_id:selected_value,
              user_name:user_name,
              mutual_filter: 'scheme',
            },
            api: 'get-user-mutual-fund-form-mobile-detail',
          }).then(() => {
          Fire.$emit('mutualFundGraphData');
          this.$loading(false) 

        }).catch(() => {
          this.$loading(false) 
        })
      },

      getAccountHelpDetail(){
        this.getFormData = document.querySelector("#saving_account");
        console.log(this.getFormData.folio_no.value)
        if(this.getFormData.folio_no.value == ''){
          swal.fire({title:"Please Folio Number"});
        }
        else if(this.getFormData.mutual_fund_company.value == ''){
          swal.fire({title:"Please enter account no."});
        }
        else{
          let formdata    = new FormData();
          formdata.append("aws_cognito_id", atob(localStorage.getItem('cognito_idp')));
          formdata.append("folio_no", this.getFormData.folio_no.value);
          formdata.append("mfc_id", this.getFormData.mutual_fund_company.value);
          axios.post( process.env.VUE_APP_ROOT_API+'get-mf-help-detail', formdata).then((res) => {
            this.missed_call_no_array = res.data.data.missed_call_no_array
            this.sms_array = res.data.data.sms_array
            this.whatsapp_no_array = res.data.data.whatsapp_no_array
            setTimeout(()=>{this.account_help_dialog = true}, 500)
          }).catch(() => {})
        }
      }
    }
};
</script>